import { render, staticRenderFns } from "./_prefecture.vue?vue&type=template&id=637e466c&scoped=true&"
import script from "./_prefecture.vue?vue&type=script&lang=js&"
export * from "./_prefecture.vue?vue&type=script&lang=js&"
import style0 from "./_prefecture.vue?vue&type=style&index=0&id=637e466c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637e466c",
  null
  
)

/* custom blocks */
import block0 from "./_prefecture.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports